module.exports = __webpack_public_path__ + "img/card.325f5ad9.png";